import { defaultDataIdFromObject } from '@apollo/client/cache/inmemory/helpers.js';
import { InMemoryCache } from '@apollo/client/cache/inmemory/inMemoryCache.js';

/**
 * Shared Apollo cache for Remix browser and SSR clients.
 *
 * ArchiPro GraphQL entities expose uppercase `ID` rather than Apollo's default
 * `id` / `_id`, so objects must be keyed as `__typename:ID`. Without this,
 * overlapping Query fields such as `getProfessional` and
 * `getProfessionalByURLSegment` replace each other and trigger Apollo warning 15.
 *
 * Imports use Apollo's deep ESM entry points so this module loads under both
 * Vite (browser) and tsx/Node (SSR server entry).
 */
export function createApolloCache(): InMemoryCache {
    return new InMemoryCache({
        dataIdFromObject(responseObject) {
            // Prefer ArchiPro uppercase ID, then lowercase id, then Apollo defaults.
            if (
                typeof responseObject === 'object' &&
                responseObject !== null &&
                '__typename' in responseObject
            ) {
                const object = responseObject as Record<string, unknown>;
                if (object.ID != null) {
                    return `${object.__typename}:${object.ID}`;
                }
                if (object.id != null) {
                    return `${object.__typename}:${object.id}`;
                }
            }
            return defaultDataIdFromObject(responseObject);
        },
    });
}
